var _defs, _polygon, _path, _path2, _path3, _g, _rect, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataFreeLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 774.84 250.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 413.56,
    y1: 81.51,
    x2: 484.15,
    y2: 81.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00537a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0194cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 484.64,
    y1: 105.79,
    x2: 550.62,
    y2: 105.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 653.77,
    y1: 110.02,
    x2: 749.56,
    y2: 110.02,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 548.45,
    y1: 89.32,
    x2: 740.49,
    y2: 89.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 14.42,
    y1: 216.04,
    x2: 388.86,
    y2: 216.04,
    xlinkHref: "#linear-gradient"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "304.55 60.28 285.85 60.28 285.85 25.56 260.38 25.56 260.38 60.28 241.68 60.28 241.68 80.41 260.38 80.41 260.38 153.96 285.85 153.96 285.85 80.41 304.55 80.41 304.55 60.28",
    fill: "#373737",
    strokeWidth: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.85,60.79v11.04c-8.05-9.1-19.25-14.75-31.64-14.75-24.5,0-44.37,22.06-44.37,49.28s19.86,49.28,44.37,49.28c12.39,0,23.59-5.65,31.64-14.75v13.08h25.45V60.79h-25.45ZM185.69,131.92c-13.68,0-24.77-11.09-24.77-24.77s11.09-24.77,24.77-24.77,24.77,11.09,24.77,24.77-11.09,24.77-24.77,24.77Z",
    fill: "#373737",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382.27,60.79v11.04c-8.05-9.1-19.25-14.75-31.64-14.75-24.5,0-44.37,22.06-44.37,49.28s19.86,49.28,44.37,49.28c12.39,0,23.59-5.65,31.64-14.75v13.08h25.45V60.79h-25.45ZM357.11,131.92c-13.68,0-24.77-11.09-24.77-24.77s11.09-24.77,24.77-24.77,24.77,11.09,24.77,24.77-11.09,24.77-24.77,24.77Z",
    fill: "#373737",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76,16.08v-.37H14.42v138.25h61.58c32.13-3.57,57.2-33.59,57.2-69.28S108.14,19.64,76,16.08ZM69.48,128.51v.02h-27.81V39.81h27.81v.02c18.9.52,34.1,20.16,34.1,44.34s-15.2,43.82-34.1,44.34Z",
    fill: "#373737",
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M442.83,19.74c-12.26,11.97-10.57,28.78-10.57,28.78v11.53h-18.7v20.13h18.7v73.55h25.47v-73.55h18.7v-20.13h-18.7v-12.71c0-1.84.93-5.26,3.79-8.03s5.34-5.14,8.21-5.14h14.42V9.34h-15.12s-13.93-1.57-26.2,10.4Z",
    fill: "url(#linear-gradient)",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.61,59.38c-8.34,3.24-14.32,13.27-16.5,17.43v-16.76h-25.47v93.68h25.47v-43.65c1.06-5.38,2.92-13.7,4.86-17.32,2.99-5.56,9.38-11.13,16.8-11.13s13.6,4.02,13.6,4.02l5.26-24.94s-13.4-5.46-24.01-1.34Z",
    fill: "url(#linear-gradient-2)",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.11,115.36h21.66c.51-2.78.79-5.64.79-8.56,0-18.34-10.45-34.34-25.95-42.82l-18,17.39c8.48,1.98,15.35,8.64,18.11,17.36h-36.07l-33.88,32.74c8.88,14.71,25.45,24.61,44.44,24.61,17.15,0,32.32-8.07,41.64-20.46l-14.86-15.5c-4.76,8-14.57,13.04-23.84,13.04-11,0-21.09-7.08-24.26-17.79h50.22Z",
    fill: "url(#linear-gradient-3)",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.45,63.98l2.04-40.87c0-.06-.05-.11-.11-.1l-40.72,4.04,12.69,9.83-44.92,42.85s-46.86,47.06-56.26,51.28c-6.53,2.93-9.48,2.73-10.68,2.33-.44.03-.89.06-1.33.06-11.23,0-20.7-8.08-23.68-19.13h48.58c-.06.21-.13.41-.2.62l22-21.95c-6.24-20.33-25.32-35.85-47.71-35.85-27.45,0-49.7,22.06-49.7,49.28s22.25,49.28,49.7,49.28c11.61,0,22.28-3.96,30.74-10.57h0s.09-.07.09-.07c2.45-1.93,4.72-4.08,6.76-6.42l91.97-87.13,10.74,12.54ZM599.15,80.31c10.6,0,19.64,7.21,23.12,17.32h-46.25c3.48-10.11,12.52-17.32,23.12-17.32Z",
    fill: "url(#linear-gradient-4)",
    strokeWidth: 0
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.42,
    y: 212.38,
    width: 374.45,
    height: 7.33,
    rx: 3.67,
    ry: 3.67,
    fill: "url(#linear-gradient-5)",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M431.46,194.21v5.42h-8.62v28.08h-6.49v-28.08h-8.62v-5.42h23.74Z",
    fill: "#373737",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.31,217.96h-18.01c.15,1.78.77,3.17,1.87,4.18,1.1,1.01,2.45,1.51,4.05,1.51,2.31,0,3.96-.99,4.94-2.98h6.72c-.71,2.37-2.08,4.32-4.09,5.85-2.02,1.53-4.49,2.29-7.43,2.29-2.37,0-4.5-.53-6.38-1.58-1.88-1.05-3.35-2.54-4.4-4.47s-1.58-4.15-1.58-6.67.52-4.79,1.56-6.72c1.04-1.93,2.49-3.41,4.36-4.45,1.87-1.04,4.02-1.56,6.45-1.56s4.44.5,6.29,1.51c1.85,1.01,3.29,2.44,4.31,4.29,1.02,1.85,1.53,3.98,1.53,6.38,0,.89-.06,1.69-.18,2.4ZM453.04,213.78c-.03-1.6-.61-2.88-1.73-3.85-1.13-.96-2.51-1.45-4.14-1.45-1.54,0-2.84.47-3.89,1.4-1.05.93-1.7,2.23-1.94,3.89h11.7Z",
    fill: "#373737",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.89,209.33c1-1.85,2.39-3.28,4.17-4.3s3.81-1.53,6.11-1.53c2.95,0,5.4.74,7.33,2.21s3.23,3.55,3.89,6.21h-6.49c-.34-1.03-.92-1.84-1.74-2.43-.82-.59-1.83-.88-3.03-.88-1.72,0-3.08.62-4.08,1.87-1,1.25-1.51,3.02-1.51,5.31s.5,4.02,1.51,5.27c1,1.25,2.36,1.87,4.08,1.87,2.44,0,4.03-1.09,4.77-3.27h6.49c-.66,2.58-1.96,4.63-3.91,6.15-1.95,1.52-4.39,2.28-7.31,2.28-2.29,0-4.33-.51-6.11-1.53-1.78-1.02-3.17-2.45-4.17-4.3-1-1.85-1.5-4.01-1.5-6.47s.5-4.62,1.5-6.47Z",
    fill: "#373737",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.12,204.73c1.4.79,2.5,1.95,3.29,3.48.79,1.53,1.18,3.38,1.18,5.53v13.97h-6.02v-13.16c0-1.89-.47-3.35-1.42-4.36s-2.24-1.53-3.87-1.53-2.97.51-3.93,1.53c-.96,1.02-1.44,2.47-1.44,4.36v13.16h-6.02v-33.5h6.02v12.65c.77-1.03,1.81-1.84,3.1-2.43s2.72-.88,4.3-.88c1.81,0,3.41.39,4.82,1.18Z",
    fill: "#373737",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.95,206.24c1.75,1.79,2.62,4.29,2.62,7.5v13.97h-6.02v-13.16c0-1.89-.47-3.35-1.42-4.36-.95-1.02-2.24-1.53-3.87-1.53s-2.97.51-3.93,1.53c-.96,1.02-1.44,2.47-1.44,4.36v13.16h-6.02v-23.82h6.02v2.97c.8-1.03,1.83-1.84,3.08-2.43s2.62-.88,4.11-.88c2.84,0,5.13.9,6.88,2.69Z",
    fill: "#373737",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.9,226.58c-1.83-1.02-3.28-2.46-4.32-4.32-1.05-1.86-1.57-4.01-1.57-6.45s.54-4.59,1.61-6.45c1.07-1.86,2.54-3.3,4.41-4.32,1.86-1.02,3.94-1.53,6.23-1.53s4.37.51,6.24,1.53,3.33,2.46,4.41,4.32c1.08,1.86,1.61,4.01,1.61,6.45s-.55,4.59-1.66,6.45-2.59,3.3-4.47,4.32c-1.88,1.02-3.98,1.53-6.3,1.53s-4.36-.51-6.19-1.53ZM578.17,222.06c.96-.53,1.73-1.33,2.3-2.39s.86-2.35.86-3.87c0-2.26-.6-4.01-1.78-5.22-1.19-1.22-2.64-1.83-4.37-1.83s-3.16.61-4.32,1.83c-1.16,1.22-1.74,2.96-1.74,5.22s.57,4.01,1.7,5.22c1.13,1.22,2.56,1.83,4.28,1.83,1.09,0,2.11-.26,3.08-.79Z",
    fill: "#373737",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.71,194.21v33.5h-6.02v-33.5h6.02Z",
    fill: "#373737",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.59,226.58c-1.83-1.02-3.28-2.46-4.32-4.32-1.05-1.86-1.57-4.01-1.57-6.45s.54-4.59,1.61-6.45c1.08-1.86,2.54-3.3,4.41-4.32s3.94-1.53,6.24-1.53,4.37.51,6.24,1.53c1.86,1.02,3.33,2.46,4.41,4.32,1.08,1.86,1.61,4.01,1.61,6.45s-.55,4.59-1.66,6.45c-1.1,1.86-2.59,3.3-4.47,4.32-1.88,1.02-3.98,1.53-6.3,1.53s-4.36-.51-6.19-1.53ZM627.85,222.06c.96-.53,1.73-1.33,2.3-2.39.57-1.06.86-2.35.86-3.87,0-2.26-.59-4.01-1.78-5.22-1.19-1.22-2.64-1.83-4.36-1.83s-3.16.61-4.32,1.83c-1.16,1.22-1.74,2.96-1.74,5.22s.57,4.01,1.7,5.22c1.13,1.22,2.56,1.83,4.28,1.83,1.09,0,2.11-.26,3.07-.79Z",
    fill: "#373737",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.88,204.56c1.35.7,2.41,1.61,3.18,2.73v-3.4h6.06v23.99c0,2.21-.45,4.18-1.33,5.91-.89,1.73-2.22,3.11-4,4.13-1.78,1.02-3.93,1.53-6.45,1.53-3.38,0-6.16-.79-8.32-2.37-2.17-1.58-3.39-3.73-3.68-6.45h5.98c.31,1.09,1,1.96,2.04,2.6,1.05.65,2.31.97,3.81.97,1.75,0,3.17-.52,4.26-1.57,1.09-1.05,1.63-2.63,1.63-4.75v-3.7c-.77,1.12-1.84,2.05-3.2,2.79-1.36.75-2.92,1.12-4.67,1.12-2.01,0-3.84-.52-5.5-1.55s-2.97-2.49-3.93-4.36c-.96-1.88-1.44-4.04-1.44-6.47s.48-4.54,1.44-6.41c.96-1.86,2.26-3.3,3.91-4.3,1.65-1,3.49-1.5,5.53-1.5,1.78,0,3.34.35,4.69,1.05ZM663.21,212.04c-.57-1.05-1.35-1.85-2.32-2.41-.97-.56-2.02-.84-3.14-.84s-2.15.27-3.1.82c-.95.54-1.71,1.34-2.3,2.39-.59,1.05-.88,2.29-.88,3.72s.29,2.69.88,3.76c.59,1.08,1.36,1.9,2.32,2.47.96.57,1.99.86,3.08.86s2.16-.28,3.14-.84c.97-.56,1.75-1.36,2.32-2.41.57-1.05.86-2.3.86-3.76s-.29-2.72-.86-3.76Z",
    fill: "#373737",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.66,200.05c-.7-.67-1.05-1.51-1.05-2.51s.35-1.84,1.05-2.52c.7-.67,1.58-1.01,2.64-1.01s1.94.34,2.64,1.01c.7.67,1.05,1.51,1.05,2.52s-.35,1.84-1.05,2.51c-.7.67-1.58,1.01-2.64,1.01s-1.94-.34-2.64-1.01ZM687.27,203.89v23.82h-6.02v-23.82h6.02Z",
    fill: "#373737",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721,217.61h-17.42c.14,1.72.75,3.07,1.81,4.04,1.06.98,2.36,1.46,3.91,1.46,2.24,0,3.83-.96,4.77-2.88h6.49c-.69,2.29-2.01,4.18-3.96,5.66-1.95,1.48-4.34,2.21-7.18,2.21-2.29,0-4.35-.51-6.17-1.53-1.82-1.02-3.24-2.46-4.26-4.32s-1.53-4.01-1.53-6.45.5-4.63,1.5-6.49c1-1.86,2.41-3.3,4.21-4.3,1.81-1,3.88-1.5,6.24-1.5s4.29.49,6.08,1.46c1.79.97,3.18,2.36,4.17,4.15.99,1.79,1.48,3.85,1.48,6.17,0,.86-.06,1.63-.17,2.32ZM714.93,213.57c-.03-1.55-.59-2.79-1.68-3.72-1.09-.93-2.42-1.4-4-1.4-1.49,0-2.75.45-3.76,1.35-1.02.9-1.64,2.16-1.87,3.76h11.31Z",
    fill: "#373737",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.65,227.05c-1.55-.7-2.77-1.66-3.68-2.86-.9-1.2-1.4-2.54-1.48-4h6.06c.11.92.57,1.68,1.35,2.28.79.6,1.77.9,2.95.9s2.04-.23,2.69-.69c.64-.46.97-1.05.97-1.76,0-.77-.39-1.35-1.18-1.74-.79-.39-2.04-.81-3.76-1.27-1.78-.43-3.23-.87-4.36-1.33-1.13-.46-2.11-1.16-2.92-2.11-.82-.95-1.23-2.22-1.23-3.83,0-1.32.38-2.52,1.14-3.61.76-1.09,1.85-1.95,3.27-2.58s3.09-.95,5.01-.95c2.84,0,5.1.71,6.79,2.13,1.69,1.42,2.62,3.33,2.79,5.74h-5.76c-.09-.95-.48-1.7-1.18-2.26-.7-.56-1.64-.84-2.82-.84-1.09,0-1.93.2-2.52.6-.59.4-.88.96-.88,1.68,0,.8.4,1.41,1.2,1.83.8.42,2.05.84,3.74,1.27,1.72.43,3.14.87,4.26,1.33,1.12.46,2.08,1.17,2.9,2.13.82.96,1.24,2.23,1.27,3.81,0,1.38-.38,2.61-1.14,3.7s-1.85,1.94-3.27,2.56c-1.42.62-3.08.92-4.97.92s-3.7-.35-5.25-1.05Z",
    fill: "#373737",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataFreeLogo1);
export default __webpack_public_path__ + "static/media/dataFreeLogo1.35b84edc4c7f724c5b62d685d8c85a77.svg";
export { ForwardRef as ReactComponent };